import React from "react";
import { Box, Grid, MenuItem, TextField, Typography } from "@mui/material";
import AgentConfigSection from "../../AgentConfigSection";
import { COMPLETION_NOTIFICATION_TYPES } from "../../emailPolicy";

export default function CompletionNotificationSection({
  completionNotificationType,
  setCompletionNotificationType,
  completionNotifyEmails,
  setCompletionNotifyEmails,
  completionSlackWebhookUrl,
  setCompletionSlackWebhookUrl,
  completionWebhookUrl,
  setCompletionWebhookUrl,
  webhookPayloadPreview,
}) {
  return (
    <AgentConfigSection id="completionNotification">
      <Grid container spacing={2} sx={{ mb: 2.5 }}>
        <Grid item xs={12}>
          <Typography className="org-field-label">
            Notification channel
          </Typography>
          <TextField
            className="org-styled-textfield"
            select
            fullWidth
            size="small"
            value={completionNotificationType}
            onChange={(e) => setCompletionNotificationType(e.target.value)}
          >
            {COMPLETION_NOTIFICATION_TYPES.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {completionNotificationType === "EMAIL" && (
          <Grid item xs={12}>
            <Typography className="org-field-label">Email recipients</Typography>
            <TextField
              className="org-styled-textfield"
              fullWidth
              size="small"
              value={completionNotifyEmails}
              onChange={(e) => setCompletionNotifyEmails(e.target.value)}
              placeholder="name@example.com, ops@example.com"
            />
            <Typography
              sx={{ fontSize: "11px", color: "text.disabled", mt: 0.5 }}
            >
              Comma-separated email addresses.
            </Typography>
          </Grid>
        )}

        {completionNotificationType === "SLACK" && (
          <Grid item xs={12}>
            <Typography className="org-field-label">
              Slack webhook URL
            </Typography>
            <TextField
              className="org-styled-textfield"
              fullWidth
              size="small"
              value={completionSlackWebhookUrl}
              onChange={(e) => setCompletionSlackWebhookUrl(e.target.value)}
              placeholder="https://hooks.slack.com/services/..."
            />
          </Grid>
        )}

        {completionNotificationType === "WEBHOOK" && (
          <Grid item xs={12}>
            <Typography className="org-field-label">
              Webhook URL (POST)
            </Typography>
            <TextField
              className="org-styled-textfield"
              fullWidth
              size="small"
              value={completionWebhookUrl}
              onChange={(e) => setCompletionWebhookUrl(e.target.value)}
              placeholder="https://your-server.com/webhooks/agent"
            />
            <Typography
              sx={{ fontSize: "11px", color: "text.disabled", mt: 0.5 }}
            >
              Receives a JSON payload with session details and direct links to
              the chat.
            </Typography>
            <Box
              sx={{
                mt: 1.5,
                border: 1,
                borderColor: "divider",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <Typography
                sx={{
                  fontSize: "11px",
                  color: "text.secondary",
                  px: 1.5,
                  py: 0.75,
                  backgroundColor: "action.hover",
                  borderBottom: 1,
                  borderColor: "divider",
                }}
              >
                Payload preview
              </Typography>
              <Box
                component="pre"
                sx={{
                  m: 0,
                  p: 1.5,
                  fontSize: "11px",
                  lineHeight: 1.45,
                  overflowX: "auto",
                  backgroundColor: "background.paper",
                  color: "text.secondary",
                }}
              >
                {JSON.stringify(webhookPayloadPreview, null, 2)}
              </Box>
            </Box>
          </Grid>
        )}
      </Grid>
    </AgentConfigSection>
  );
}
